import type { UseFormReturnType } from "@mantine/form";

/**
 * Dismisses a Mantine drawer form without relying on `form.reset()` alone: in Mantine 7, `reset()`
 * ignores arguments and restores the snapshot from first `useForm` mount. This helper sets live
 * values, updates the baseline via `setInitialValues`, clears dirty state, and clears errors.
 *
 * @param form Mantine `useForm` return value (only the methods used here are required).
 * @param snapshot Full form object to apply (for example `getInitialValues(null)` on close).
 */
export function replaceFormSnapshotForDrawerDismiss<T extends Record<string, unknown>>(
  form: Pick<UseFormReturnType<T>, "clearErrors" | "resetDirty" | "setInitialValues" | "setValues">,
  snapshot: T,
): void {
  form.setValues(snapshot);
  form.setInitialValues(snapshot);
  form.resetDirty(snapshot);
  form.clearErrors();
}
